import { Autocomplete as MuiAutocomplete, TextField, AutocompleteProps } from '@mui/material';
import React from 'react';

type TAutocompleteProps<T> = Omit<AutocompleteProps<T, false, false, false>, 'renderInput'> & {
  label?: string;
  disabled?: boolean;
};

export function Autocomplete<T>({
  label,
  disabled,
  ...rest
}: TAutocompleteProps<T>) {
  return (
    <MuiAutocomplete<T, false, false, false>
      {...rest}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant='outlined'
        />
      )}
    />
  );
}
